import { Trans } from "@lingui/react/macro";
import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query";

import { Button } from "@/common/components/button/button";
import {
  CompanyForm,
  Fields,
  getInitialValues,
} from "@/common/components/company-form/company-form";
import { Spacer } from "@/common/components/spacer/spacer";
import { toaster } from "@/common/components/toast/toast";
import { useUpdateCompanyMutation } from "@/common/components/user-settings/components/company-form/company-form.api";
import { splitCallingCodeAndCountry } from "@/common/utils/phone";

import { companyQuery } from "../company.api";
import { useCompanyId } from "../use-company-id";

const Detail = () => {
  const queryClient = useQueryClient();
  const id = useCompanyId();
  const company = useSuspenseQuery(companyQuery({ id: parseInt(id) }));
  const updateCompany = useUpdateCompanyMutation();

  const handleSubmit = (data: Fields) => {
    updateCompany.mutate(
      {
        address: data.address,
        companyForm: data.legalForm,
        contactEmail: data.contact.email,
        contactName: data.contact.name,
        contactPhone: {
          countryCode: splitCallingCodeAndCountry(
            data.contact.phone.countryCode,
          ).at(0)!,
          phoneNumber: data.contact.phone.phoneNumber,
        },
        contactPosition: data.contact.role,
        id: parseInt(id),
        vat: data.vat,
      },
      {
        onError: () => {
          toaster.error(
            {
              title: (
                <Trans>Nepodařilo se uložit informace o společnosti</Trans>
              ),
            },
            { autoClose: 2000 },
          );
        },
        onSuccess: () => {
          void queryClient.invalidateQueries();
        },
      },
    );
  };

  return (
    <details>
      <summary>
        <h2 className="inline text-lg font-bold">
          <Trans>Informace</Trans>
        </h2>
      </summary>
      <Spacer className="h-6" />
      <CompanyForm
        disabledFields={[]}
        initialValues={getInitialValues(company.data)}
        onSubmit={handleSubmit}
      />
      <Button.Container>
        <Button
          disabled={updateCompany.status === "pending"}
          form="company-form"
          type="submit"
          variant="primary"
        >
          <Trans>Uložit</Trans>
        </Button>
      </Button.Container>
    </details>
  );
};

export { Detail };
